module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-07-09378f4316c14a849cd078ee60f2d419.jpg";